import React from "react";
import { FigureCard, CardHeader } from "@adeccoux/tag-ds";

const SingleSelectTab = ({ singleSelectData, setSingleSelectData, data }) => {
    return (
        <div className="flex_row flex_wrap g2">
            {data.map((val, ind) => (
                <FigureCard
                    key={ind}
                    onClick={() => setSingleSelectData(val.position)}
                    selected={singleSelectData == val.position}
                    className="pb3 px11 mb3"
                >
                    <CardHeader id="figure card header">
                        <h4
                            dangerouslySetInnerHTML={{
                                __html: val.content,
                            }}
                        />
                    </CardHeader>
                </FigureCard>
            ))}
        </div>
    );
};

export default SingleSelectTab;
